// extracted by mini-css-extract-plugin
export default {"avatar":"Q94nZ1","withBorder":"iN8Moe","memberInitials":"WgIltU","avatarPlaceholder":"jqr5zx"};